var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.photoList),function(photo){return _c('div',{key:photo.id,staticClass:"image-content"},[_c('div',[_c('img',{attrs:{"src":photo.imageUrl}})]),_c('div',{staticClass:"del",on:{"click":function($event){return _vm.deletePhoto(photo)}}},[_vm._v("删除")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }